import { DataUpdateStatus } from "../../../shared-gen/Device/Updates/Data/DataUpdateStatus";
import { DataUpdateState }  from "../../../shared-gen/Device/Updates/Data/DataUpdateState";

export class DataUpdateStatusFun {

	static createNew(): DataUpdateStatus {
		return {
			State: DataUpdateState.UpToDate,
			DeviceUpdate: null as any,
			ImageIndex: null as any,
			ImagesCount: null as any
		};
	}

}
